import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDoj0oP_y7GMRiW8XLqSNqtzAx90xyLB1U",
  authDomain: "andrey-dum.firebaseapp.com",
  projectId: "andrey-dum",
  storageBucket: "andrey-dum.appspot.com",
  messagingSenderId: "37790393772",
  appId: "1:37790393772:web:e78d88340d46dad8910609"
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

export default db;
